setTimeout(function(){
    if(document.querySelector('.bn-intro')) {
        document.querySelector('.bn-intro').classList.add('--closed');
        sessionStorage.setItem("intro-closed", "1");
    }
}, 4800);


// WEBPACK FOOTER //
// ./source/js/modules/lib/intro.js